const MESSAGES = {
  'auth/invalid-credential': 'Incorrect email or password.',
  'auth/wrong-password': 'Incorrect email or password.',
  'auth/user-not-found': 'Incorrect email or password.',
  'auth/invalid-email': 'That email address looks invalid.',
  'auth/missing-password': 'Please enter a password.',
  'auth/weak-password': 'Password should be at least 6 characters.',
  'auth/email-already-in-use': 'An account with this email already exists. Try logging in instead.',
  'auth/too-many-requests': 'Too many attempts. Please wait a moment and try again.',
  'auth/network-request-failed': 'Network error. Please check your connection and try again.',
  'auth/user-disabled': 'This account has been disabled. Contact support if you think this is a mistake.',
  'auth/account-exists-with-different-credential':
    'An account already exists with this email using a different sign-in method. Try logging in with that method instead.',
  'auth/popup-blocked': 'Your browser blocked the sign-in popup. Please allow popups for this site and try again.',
};

// Codes that just mean "the user backed out" — not worth showing as an error.
export const isDismissedAuthError = (error) =>
  ['auth/popup-closed-by-user', 'auth/cancelled-popup-request'].includes(error?.code);

export const getAuthErrorMessage = (error) =>
  MESSAGES[error?.code] || 'Something went wrong. Please try again.';
